const config = {
  dataUrl: '/node/home/property-type-images',
  options: {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  }
};

const DEFAULT_PROPERTY_TYPE_IMAGES = {};

const getPropertyTypeImages = (tags = []) => {
  const query = tags.map(tag => `tags=${tag}`).join('&');
  return fetch(`${config.dataUrl}?${query}`, config.options)
    .then((response) => {
      if (!response.ok) {
        throw new Error('Response not 200 OK');
      }
      return response;
    })
    .then(response => response.json())
    .catch(() => DEFAULT_PROPERTY_TYPE_IMAGES);
};

export { getPropertyTypeImages, config };
